import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a view for filtering products by bet shop.
 * @extends JetView
 */
export default class FilterProductsThirdByBetShopView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section with ID input
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Id', // Input field for ID
                    type: 'number',
                    label: _("<span class='icon-drivers-license-o'></span>ID"),
                    labelPosition: 'top',
                    placeholder: _('ID'),
                },
            ],
        };

        // Center left section with product selection
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'ProductsThird', // Combo box for selecting third-party products
                    id: 'ProductsThird',
                    label: _('Producto Terceros'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
            ],
        };

        // Center right section with activation status selection
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect',
                    name: 'IsActivate', // Rich select for activation status
                    label: _("<span class='icon-state'></span> Estado"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'null', value: 'Todos' },
                        { id: 'A', value: 'Activado' },
                        { id: 'I', value: 'Inactivado' },
                    ],
                },
            ],
        };

        // Right section (currently empty)
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Upper section containing the main input fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Añadir'), // Button to add products
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        this.app.callEvent('addProductsThird:button', [{}]); // Trigger add event
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'), // Button to clear the form
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear form values
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Button to consult/filter products
                    hotkey: 'enter',
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('productsThird:filter', [
                            filterdata, // Trigger filter event with form values
                        ]);
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and loads data from the API.
     */
    init() {
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for the request
            })
            .post(
                devConfig.geturlApi() + 'Accounting/GetProductsThirdSelect', // API endpoint
                '',
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Error handling
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse response
                        $$('ProductsThird').define('options', resp.Data); // Set options for the combo box
                        $$('ProductsThird').refresh(); // Refresh the combo box
                    },
                },
            );
    }
}

// FILE DOCUMENTED
